module.exports = __webpack_public_path__ + "img/logo.edcee99c.png";